import React from 'react';

/** Tabler / forwardRef 아이콘 컴포넌트 여부 (문자열·엘리먼트와 구분). */
export function isUiIconComponent(value) {
  if (typeof value === 'function') return true;
  return Boolean(value && typeof value === 'object' && (value.$$typeof || value.render));
}

/**
 * 이모지 문자열 / React 노드 / Tabler 컴포넌트를 안전하게 렌더.
 * `{IconCar}`처럼 컴포넌트 객체를 자식으로 넣으면 React #31이 난다.
 */
export function renderUiIcon(value, props = {}) {
  if (value == null || value === false) return null;
  if (React.isValidElement(value)) return value;
  if (isUiIconComponent(value)) {
    return React.createElement(value, {
      size: 16,
      stroke: 2,
      'aria-hidden': true,
      ...props,
    });
  }
  return value;
}
